import Vue from 'vue';
import BaseUI from 'base-ui';

import DDLogs from '@/DDLogs';
import Segment from '@/Segment';
import Sentry from '@/Sentry';
import Intercom from '@/Intercom';
import App from '@/App';
import router from '@/router';
import store from '@/store';
import config from '@/config';
import initLiveSession from '@/livesession';
import initInterceptors from '@/api/interceptors';
import CustomerPiiPlugin from './plugins/CustomerPii';
import '@/quasar';
import '@/style';
import '@/validations';
import '@/dayjs';
import '@/touch-events';
import '@lottiefiles/lottie-player';
import '@/slider';

config.fetch().then(() => {
  Vue.config.productionTip = false;

  initLiveSession(config.get());
  DDLogs.init();
  Sentry.init();
  initInterceptors();
  Vue.use(Segment);
  Vue.use(CustomerPiiPlugin);
  Vue.use(Intercom);
  Vue.use(BaseUI);

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
});
